const Menu = ({value}) => {
  return (
    <ul className="nav nav-tabs tabContent">
      <li role="presentation" className={value === "home" ? "active" : ""}>
        <a href="/"><img src={require("./Theme/img/tab/tab1.png")} /> TẤT CẢ</a>
      </li>
      <li role="presentation" className={value === "video" ? "active" : ""}>
        <a href="/video"> <img src={require("./Theme/img/tab/tab2.png")} /> VIDEO</a>
      </li>
      <li role="presentation" className={value === "audio" ? "active" : ""}>
        <a href="/audio"> <img src={require("./Theme/img/tab/tab3.png")} /> AUDIO</a>
      </li>
      <li role="presentation" className={value === "kinhsach" ? "active" : ""}>
        <a href="/kinh-sach"> <img src={require("./Theme/img/tab/tab4.png")} /> KINH SÁCH</a>
      </li>
      <li role="presentation" className={value === "sachnoi" ? "active" : ""}>
        <a href="/sach-noi"> <img src={require("./Theme/img/tab/tab5.png")} /> SÁCH NÓI</a>
      </li>
      <li role="presentation" className={value === "nhacphat" ? "active" : ""}>
        <a href="/nhac-phat-giao"> <img src={require("./Theme/img/tab/tab6.png")} /> NHẠC PHẬT GIÁO</a>
      </li>
    </ul>
  );
}

export default Menu;
